import {apiClient} from "../../services/api";

export class UserProfileDataSource {
    static path = "/security";

    static userProfile(bodyParams) {
        return apiClient.post(`${this.path}/myadmin-user/login-profile`, bodyParams);
    }

    static verifyAccesstoken(bodyParams) {
        return apiClient.post(`${this.path}/token/verify-accesstoken`, bodyParams);
    }

    static mobileUserProfileByAppAccessToken(bodyParams) {
        return apiClient.post(`${this.path}/myadmin-user/mobile-user-profile-by-app-access-token`, bodyParams);
    }
}
